import { Grid } from '@mui/material';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {
    getDryIcePurchasedPerFacility,
    getFertilizersPerFacility,
    getFuelCombustedPerFacility,
    getLpgCombustedPerFacility,
    getRefrigerantGasTopUpsPerFacility
} from '../../../../../../../actions/carbonfootprint-rework/06-dashboard/01-dashboard';
import { DataAccordion } from '../../../../../../shared-components/DataAccordion';
import GraphSubHeader from '../../../shared-components/GraphSubHeader';
import GraphPairForFacilities from '../../../shared-components/GraphPairForFacilities';
import MainCategoryButtons from '../../../shared-components/MainCategoryButtons';
import GraphMainHeader from '../../../shared-components/GraphMainHeader';
import FertilizerGraphPairForFacilities from '../../../shared-components/FertilizerGraphPairForFacilities';

export const ScopeOneConsumptionFacilities = ({ openAccordion, changeAccordion, company, title, group, year, groupName, groupFacilities }) => {
    const dispatch = useDispatch();
    const [selectedCategory, setSelectedCategory] = useState('Stationary Combustion');

    const scopeOneFacilityCategories = ['Stationary Combustion', 'Mobile Combustion', "Fugitive Emissions"]
    const accordionName = 'Scope One Consumption Facility'

    // stationary graphs
    const fuelCombustedDieselStationaryPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedDieselStationaryPerFacility?.data?.graph);
    // const fuelCombustedPetrolStationaryPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedPetrolStationaryPerFacility?.data?.graph);
    // stationary pies
    const fuelCombustedDieselStationaryPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedDieselStationaryPerFacility?.data?.pie);
    // const fuelCombustedPetrolStationaryPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedPetrolStationaryPerFacility?.data?.pie);

    // mobile graphs
    const fuelCombustedDieselMobilePerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedDieselMobilePerFacility?.data?.graph);
    const fuelCombustedPetrolMobilePerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedPetrolMobilePerFacility?.data?.graph);
    // mobile pies
    const fuelCombustedDieselMobilePerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedDieselMobilePerFacility?.data?.pie);
    const fuelCombustedPetrolMobilePerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.fuelCombustedPetrolMobilePerFacility?.data?.pie);
    // lpg
    const lpgCombustedPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.lpgCombustedPerFacility?.data?.graph);
    const lpgCombustedPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.lpgCombustedPerFacility?.data?.pie);
    //fugitive emissions
    const refrigerantGasTopUpsPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.refrigerantGasTopUpsPerFacility?.data?.graph)
    const refrigerantGasTopUpsPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.refrigerantGasTopUpsPerFacility?.data?.pie)

    const dryIcePurchasedPerFacilityGraph = useSelector(state => state.carbonFootprintDashboardReducer.dryIcePurchasedPerFacility?.data?.graph);
    const dryIcePurchasedPerFacilityPie = useSelector(state => state.carbonFootprintDashboardReducer.dryIcePurchasedPerFacility?.data?.pie);

    const fertilizersPerFacilityGraph = useSelector((state) => (state.carbonFootprintDashboardReducer.fertilizersPerFacility?.data?.graph))
    const fertilizersPerFacilityPie = useSelector((state) => (state.carbonFootprintDashboardReducer.fertilizersPerFacility?.data?.pie))

    useEffect(() => {
        if (openAccordion === accordionName && company && year && group && selectedCategory) {
            if (selectedCategory === 'Stationary Combustion') {
                dispatch(getFuelCombustedPerFacility(company, group, year, 'diesel-stationary'));
                dispatch(getLpgCombustedPerFacility(company, group, year));
            }
            else if (selectedCategory === "Mobile Combustion") {
                dispatch(getFuelCombustedPerFacility(company, group, year, 'diesel-mobile'))
                dispatch(getFuelCombustedPerFacility(company, group, year, 'petrol-mobile'))
            }
            else if (selectedCategory === "Fugitive Emissions") {
                // get data for fugitive emissions
                dispatch(getRefrigerantGasTopUpsPerFacility(company, group, year))
                dispatch(getDryIcePurchasedPerFacility(company, group, year))
                dispatch(getFertilizersPerFacility(company, group, year))
            }
        }
    }, [dispatch, openAccordion, company, year, group, selectedCategory])

    // fuelCombustedDieselStationaryPerFacility: [],
    // fuelCombustedDieselMobilePerFacility: [],
    // fuelCombustedPetrolMobilePerFacility: [],

    return (
        // defaultExpanded
        <DataAccordion
            title={title}
            show={openAccordion === accordionName}
            handleChange={() => changeAccordion(accordionName)}
        >
            <MainCategoryButtons mainCategories={scopeOneFacilityCategories} selectedCategory={selectedCategory} setSelectedCategory={setSelectedCategory} />

            <Grid container mb={'3rem'}>
                {selectedCategory === 'Stationary Combustion' &&
                    <>
                        <GraphMainHeader>{selectedCategory} {year}</GraphMainHeader>

                        <GraphSubHeader>Diesel Stationary</GraphSubHeader>
                        <GraphPairForFacilities
                            barGraphData={fuelCombustedDieselStationaryPerFacilityGraph}
                            pieChartData={fuelCombustedDieselStationaryPerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'Diesel Stationary Combustion'}
                            unit={'Litres'} />

                        <GraphSubHeader>Liquefied Petroleum Gas (LPG)</GraphSubHeader>
                        <GraphPairForFacilities
                            barGraphData={lpgCombustedPerFacilityGraph}
                            pieChartData={lpgCombustedPerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'LPG Combustion'}
                            unit={'KG'} />
                    </>
                }
                {selectedCategory === 'Mobile Combustion' &&
                    <>
                        <GraphMainHeader>{selectedCategory} {year}</GraphMainHeader>

                        <GraphSubHeader>Diesel Mobile</GraphSubHeader>
                        <GraphPairForFacilities
                            barGraphData={fuelCombustedDieselMobilePerFacilityGraph}
                            pieChartData={fuelCombustedDieselMobilePerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'Diesel Mobile Combustion'}
                            unit={'Litres'} />

                        <GraphSubHeader>Petrol Mobile</GraphSubHeader>
                        <GraphPairForFacilities
                            barGraphData={fuelCombustedPetrolMobilePerFacilityGraph}
                            pieChartData={fuelCombustedPetrolMobilePerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'Petrol Mobile Combustion'}
                            unit={'Litres'} />
                    </>
                }
                {selectedCategory === 'Fugitive Emissions' &&
                    <>
                        <GraphMainHeader>{selectedCategory} {year}</GraphMainHeader>

                        <GraphSubHeader>Refrigerant Gas</GraphSubHeader>
                        <GraphPairForFacilities
                            barGraphData={refrigerantGasTopUpsPerFacilityGraph}
                            pieChartData={refrigerantGasTopUpsPerFacilityPie}
                            groupName={groupName}
                            facilities={groupFacilities}
                            year={year}
                            type={'Refrigerant Gas Top Ups'}
                            unit={'Kilograms'} />

                        {groupName !== 'Vinimark Trading' &&
                            <>
                                <GraphSubHeader>Dry Ice</GraphSubHeader>
                                <GraphPairForFacilities
                                    barGraphData={dryIcePurchasedPerFacilityGraph}
                                    pieChartData={dryIcePurchasedPerFacilityPie}
                                    groupName={groupName}
                                    facilities={groupFacilities}
                                    year={year}
                                    type={'Dry Ice Purchased'}
                                    unit={'Kilograms'}
                                />
                            </>
                        }
                        <GraphSubHeader>Fertilizers Applied</GraphSubHeader>
                        <FertilizerGraphPairForFacilities
                            barGraphData={fertilizersPerFacilityGraph}
                            pieChartData={fertilizersPerFacilityPie}
                            groupName={groupName}
                            year={year}
                            type={'Fertilizers Applied'}
                            unit={'Kilograms'}
                        />
                    </>
                }
            </Grid>
        </DataAccordion>
    )
}
